import React from "react";
import { Loader2 } from "lucide-react";
import { useUser } from "@/lib/userContext";
import { BrandMark } from "@/components/Brand";

/**
 * Renders children only if user is signed in (any user — no admin check).
 * Otherwise shows a premium login gate.
 */
export default function AuthGate({ children, title = "Sign in to continue", subtitle = "Use your Google account to apply and track your application." }) {
    const { user, loading, signIn } = useUser();

    if (loading) {
        return (
            <div className="min-h-[60vh] grid place-items-center">
                <Loader2 className="animate-spin text-saffron" size={24} />
            </div>
        );
    }

    if (user) return children;

    return (
        <section className="min-h-[60vh] flex items-center justify-center px-6 py-24" data-testid="auth-gate">
            <div className="card-surface max-w-md w-full p-10 text-center">
                <div className="flex justify-center mb-6">
                    <BrandMark size={44} />
                </div>
                <div className="eyebrow text-saffron mb-3">Restricted · Sign in required</div>
                <h2 className="font-display text-2xl tracking-tight mb-4">{title}</h2>
                <p className="text-white/55 text-sm mb-8 leading-relaxed">{subtitle}</p>
                <button
                    onClick={() => signIn()}
                    className="btn-primary w-full justify-center"
                    data-testid="auth-gate-google-btn"
                >
                    Continue with Google
                </button>
                <p className="text-white/35 text-xs mt-6 leading-relaxed">
                    We use Google sign-in to keep your applications safe and let you track them anytime from your dashboard.
                </p>
            </div>
        </section>
    );
}
